import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Privacy() {
    useEffect(() => {
  window.scrollTo(0, 0);
}, []);
  const navigate = useNavigate();

  const section = (title, children) => (
    <div style={{ marginBottom: '2.5rem' }}>
      <h2 style={{ color: '#00D4AA', fontSize: '1.2rem', marginBottom: '1rem', borderBottom: '1px solid #1a2640', paddingBottom: '0.5rem' }}>
        {title}
      </h2>
      {children}
    </div>
  );

  const p = (text) => (
    <p style={{ color: '#8899aa', lineHeight: 1.8, marginBottom: '0.75rem', fontSize: '0.95rem' }}>{text}</p>
  );

  const li = (text) => (
    <li style={{ color: '#8899aa', lineHeight: 1.8, marginBottom: '0.4rem', fontSize: '0.95rem' }}>{text}</li>
  );

  return (
    <div style={{ background: '#0A0F1E', minHeight: '100vh', color: 'white', fontFamily: 'Arial, sans-serif', padding: '1.5rem', boxSizing: 'border-box' }}>

      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '3rem' }}>
        <span onClick={() => navigate('/')}
          style={{ color: '#00D4AA', fontWeight: 'bold', fontSize: '1.5rem', cursor: 'pointer' }}>
          CrackPrep
        </span>
        <button onClick={() => navigate(-1)}
          style={{ background: 'transparent', color: '#8899aa', border: '1px solid #1a2640', padding: '0.5rem 1rem', borderRadius: '6px', cursor: 'pointer' }}>
          ← Back
        </button>
      </div>

      <div style={{ maxWidth: '800px', margin: '0 auto' }}>

        <h1 style={{ fontSize: '2rem', fontWeight: 'bold', marginBottom: '0.5rem' }}>Privacy Policy</h1>
        <p style={{ color: '#8899aa', marginBottom: '3rem', fontSize: '0.9rem' }}>
          Last updated: May 2026 &nbsp;·&nbsp; Effective immediately upon use of the platform
        </p>

        {section('1. Introduction',
          <>
            {p('CrackPrep ("we", "us", "our") is committed to protecting your personal data. This Privacy Policy explains what information we collect, how we use it, and your rights regarding that information.')}
            {p('By using CrackPrep, you consent to the collection and use of your data as described in this policy.')}
          </>
        )}

        {section('2. Data We Collect',
          <>
            {p('We collect the following categories of data:')}
            <ul style={{ paddingLeft: '1.5rem', marginBottom: '0.75rem' }}>
              {li('Account data: your email address and name (collected via Clerk authentication)')}
              {li('Resume data: the text extracted from your uploaded resume')}
              {li('Job data: target job title, company name, and job description you provide')}
              {li('Analysis results: ATS scores, resume improvement suggestions, and interview preparation material generated for your use')}
              {li('Payment data: transaction IDs and plan information (we do not store card details — payments are processed by Razorpay)')}
              {li('Usage data: timestamps of analyses, plan purchases, and account activity')}
            </ul>
          </>
        )}

        {section('3. How We Use Your Data',
          <>
            {p('We use your data exclusively to:')}
            <ul style={{ paddingLeft: '1.5rem', marginBottom: '0.75rem' }}>
              {li('Generate your ATS score, resume improvements, and interview preparation material')}
              {li('Store your analysis history as per your purchased plan limits')}
              {li('Process and verify your payments')}
              {li('Authenticate your identity and manage your account')}
              {li('Improve the quality and accuracy of our AI outputs over time')}
              {li('Send transactional communications (e.g. payment confirmations)')}
            </ul>
            {p('We do not sell, rent, or share your personal data with third parties for marketing purposes.')}
          </>
        )}

        {section('4. Data Storage',
          <>
            {p('Your data is stored across the following secure services:')}
            <ul style={{ paddingLeft: '1.5rem', marginBottom: '0.75rem' }}>
              {li('Neon (PostgreSQL): stores your account details, plan information, and analysis metadata')}
              {li('Cloudflare R2: stores the full JSON content of your analysis results (ATS scores, resume suggestions, interview questions)')}
              {li('Clerk: manages your authentication credentials and session data')}
            </ul>
            {p('All data is stored on servers located outside India. By using CrackPrep you consent to this cross-border transfer of data.')}
          </>
        )}

        {section('5. Data Retention',
          <>
            {p('Analysis history is retained according to your plan:')}
            <ul style={{ paddingLeft: '1.5rem', marginBottom: '0.75rem' }}>
              {li('Free plan: last 1 analysis retained permanently')}
              {li('ResumePlus / InterviewPlus: last 3 analyses retained permanently')}
              {li('ResumePro / InterviewPro: last 7 analyses retained permanently')}
              {li('Elite: last 15 analyses retained permanently')}
            </ul>
            {p('When your history limit is reached, the oldest analysis is automatically deleted (FIFO) to make room for new ones. Both the database record and the stored file are permanently deleted.')}
            {p('When you delete an analysis manually, it is immediately and permanently removed from all our systems.')}
            {p('If you delete your account, all associated data including analyses, resume text, and account information will be permanently deleted within 30 days.')}
          </>
        )}

        {section('6. Third-Party Services',
          <>
            {p('CrackPrep uses the following third-party services to operate the platform:')}
            <ul style={{ paddingLeft: '1.5rem', marginBottom: '0.75rem' }}>
              {li('Google Gemini AI: your resume text and job description are sent to Google\'s API to generate AI outputs. Google\'s data processing terms apply.')}
              {li('Clerk: handles user authentication. Clerk\'s privacy policy applies to authentication data.')}
              {li('Razorpay: processes payments. Razorpay\'s privacy policy applies to payment data.')}
              {li('Cloudflare R2: stores analysis files. Cloudflare\'s privacy policy applies.')}
              {li('Neon: hosts our database. Neon\'s privacy policy applies.')}
            </ul>
            {p('We recommend reviewing the privacy policies of these services for complete information on how they handle your data.')}
          </>
        )}

        {section('7. Cookies',
          <>
            {p('CrackPrep uses minimal cookies strictly necessary for authentication and session management via Clerk. We do not use advertising cookies or third-party tracking cookies.')}
          </>
        )}

        {section('8. Your Rights',
          <>
            {p('Under applicable Indian data protection law (DPDP Act 2023), you have the right to:')}
            <ul style={{ paddingLeft: '1.5rem', marginBottom: '0.75rem' }}>
              {li('Access the personal data we hold about you')}
              {li('Request correction of inaccurate data')}
              {li('Request deletion of your data and account')}
              {li('Withdraw consent to data processing')}
            </ul>
            {p('To exercise any of these rights, please contact us at support@crackprep.in. We will respond within 30 days.')}
          </>
        )}

        {section('9. Data Security',
          <>
            {p('We implement appropriate technical and organisational measures to protect your data against unauthorised access, alteration, disclosure, or destruction. These include SSL encryption, authenticated API access, and role-based access controls.')}
            {p('However, no method of transmission over the internet or electronic storage is 100% secure. We cannot guarantee absolute security of your data.')}
          </>
        )}

        {section('10. Children\'s Privacy',
          <>
            {p('CrackPrep is not intended for users under the age of 18. We do not knowingly collect data from minors. If you believe a minor has provided us with personal data, please contact us and we will delete it promptly.')}
          </>
        )}

        {section('11. Changes to This Policy',
          <>
            {p('We may update this Privacy Policy from time to time. Changes will be posted at crackprep.in/privacy with an updated effective date. Continued use of the Platform after changes constitutes your acceptance of the updated policy.')}
          </>
        )}

        {section('12. Contact',
          <>
            {p('For privacy-related queries or to exercise your data rights, contact us at:')}
            {p('Email: privacy@crackprep.in')}
            {p('Website: https://crackprep.in')}
          </>
        )}

      </div>
    </div>
  );
}